module.exports = __webpack_public_path__ + "static/media/eu-sozialfonds.a251f69f.jpeg";